import { create } from "zustand";

type StepStore = {
  step: 0;
  setStep: (step: number) => void;
  increaseStep: () => void;
  decreaseStep: () => void;
};

const filterStepStore = (set: any): StepStore => ({
  step: 0,

  setStep: (step) => set({ step }),

  increaseStep: () => set((state: StepStore) => ({ step: state.step + 1 })),

  decreaseStep: () => set((state: StepStore) => ({ step: state.step - 1 })),
});

const useFilterStepStore = create(filterStepStore);

export default useFilterStepStore;
